/**
 * Staff routes shared by admin + clinician + reception roles. These cover
 * all clinician-safe screens (patient list, charts, calendar, exercises).
 *
 * Admin-only routes (finances, settings, marketing, etc.) live in
 * AdminOnlyRoutes.
 */
import React from 'react';
import { Route } from 'react-router-dom';
import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminPatients from '../pages/admin/AdminPatients';
import AdminAppointments from '../pages/admin/AdminAppointments';
import AdminCalendar from '../pages/admin/AdminCalendar';
import AdminExercises from '../pages/admin/AdminExercises';
import AdminSecurity from '../pages/admin/AdminSecurity';
import AdminKPIs from '../pages/admin/AdminKPIs';
import AdminWaitlist from '../pages/admin/AdminWaitlist';
import PatientChart from '../pages/admin/PatientChart';
import ObjectiveAssessment from '../pages/admin/ObjectiveAssessment';
import ClinicalNote from '../pages/admin/ClinicalNote';
import MassageAssessment from '../pages/admin/MassageAssessment';
import PatientProgression from '../pages/admin/PatientProgression';
import ShareProgressManager from '../pages/admin/ShareProgressManager';
import AdminWave5 from '../pages/admin/AdminWave5';
import PostureCapture from '../pages/admin/PostureCapture';
import PatientOutcomes30Day from '../pages/admin/PatientOutcomes30Day';
import AdminGpEarnings from '../pages/admin/AdminGpEarnings';
import AdminGpInbound from '../pages/admin/AdminGpInbound';
import PatientInterview from '../pages/PatientInterview';
import TreatmentPlanPage from '../pages/TreatmentPlan';
import PatientOutcomes from '../pages/PatientOutcomes';
import PatientProgress from '../pages/PatientProgress';
import Telehealth from '../pages/Telehealth';
import AdminFitness from '../pages/admin/AdminFitness';
import FitnessAssessment from '../pages/admin/FitnessAssessment';
import PromSurvey from '../pages/PromSurvey';
import PromTrend from '../pages/PromTrend';
import { OperationsManual, ClinicSetupManual } from '../pages/OpsManualAndFaq';
import MyAvailability from '../pages/MyAvailability';

export const staffRoutes = (
  <>
    <Route path="/admin" element={<AdminDashboard />} />
    <Route path="/admin/patients" element={<AdminPatients />} />
    <Route path="/admin/patients/:patient_id/interview" element={<PatientInterview mode="admin" />} />
    <Route path="/admin/patients/:patient_id/chart" element={<PatientChart />} />
    <Route path="/admin/patients/:patient_id/treatment-plan" element={<TreatmentPlanPage mode="admin" />} />
    <Route path="/admin/patients/:patient_id/objective-assessment" element={<ObjectiveAssessment />} />
    <Route path="/admin/patients/:patient_id/massage-assessment" element={<MassageAssessment />} />
    <Route path="/admin/patients/:patient_id/progression" element={<PatientProgression />} />
    <Route path="/admin/patients/:patient_id/share-progress" element={<ShareProgressManager />} />
    <Route path="/admin/wave5" element={<AdminWave5 />} />
    <Route path="/admin/posture-capture" element={<PostureCapture />} />
    <Route path="/admin/gp-earnings" element={<AdminGpEarnings />} />
    <Route path="/admin/gp-inbound" element={<AdminGpInbound />} />
    <Route path="/admin/patients/:patient_id/outcomes-30day" element={<PatientOutcomes30Day />} />
    <Route path="/admin/patients/:patient_id/note" element={<ClinicalNote />} />
    <Route path="/admin/patients/:patient_id/progress" element={<PatientProgress />} />
    <Route path="/admin/patients/:patient_id/outcomes" element={<PatientOutcomes />} />
    <Route path="/admin/patients/:patient_id/proms" element={<PromSurvey />} />
    <Route path="/admin/patients/:patient_id/proms/:survey_key" element={<PromSurvey />} />
    <Route path="/admin/patients/:patient_id/proms-trend/:survey_key" element={<PromTrend />} />
    <Route path="/admin/appointments" element={<AdminAppointments />} />
    <Route path="/admin/appointments/:appointment_id/telehealth" element={<Telehealth />} />
    <Route path="/admin/calendar" element={<AdminCalendar />} />
    <Route path="/admin/exercises" element={<AdminExercises />} />
    <Route path="/admin/security" element={<AdminSecurity />} />
    <Route path="/admin/kpis" element={<AdminKPIs />} />
    <Route path="/admin/waitlist" element={<AdminWaitlist />} />
    <Route path="/admin/fitness" element={<AdminFitness />} />
    <Route path="/admin/fitness/clients/:client_id/assessments" element={<FitnessAssessment />} />
    <Route path="/admin/operations-manual" element={<OperationsManual />} />
    <Route path="/admin/setup-manual" element={<ClinicSetupManual />} />
    {/* Iter 116 — Clinician self-serve availability panel. */}
    <Route path="/staff/my-availability" element={<MyAvailability />} />
  </>
);
